import Marquee from "react-fast-marquee";

const TICKER_ITEMS = [
  "VIRTUAL TRY-ON",
  "AI STYLING",
  "VISUAL MERCHANDISING",
  "GENAI CONTENT AT SCALE",
  "AI TECHPACKING",
  "PLANOGRAM INTELLIGENCE",
  "OPERATING INTELLIGENCE LAYER",
];

const MarqueeTicker = () => (
  <div
    data-testid="marquee-ticker"
    className="bg-[#0A0A0A] py-4 overflow-hidden border-y border-[#00FF66]/20"
  >
    <Marquee speed={55} gradient={false} pauseOnHover>
      {TICKER_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-cabinet font-black uppercase text-lg md:text-xl tracking-widest text-white/80 mx-6">
            {item}
          </span>
          <span className="text-[#00FF66] text-xl mx-2 font-black">//</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default MarqueeTicker;
